import Root from '@/components/Root.vue';
// eslint-disable-next-line import/no-cycle
import auth from '@/router/modules/auth';
import contactUs from '@/router/modules/contactUs';
import terms from '@/router/modules/terms';
import searchOutput from '@/router/modules/mainSearch';
import CreatorSchool from '@/router/modules/creator-school';
import AdminModule from '@/router/modules/admin';
import TrybHomepage from '@/pages/homepage/TrybHomepage.vue';
import { Role } from '@/utils/auth';
import PassThrough from '@/components/PassThrough.vue';
import communities from '@/router/modules/communities';

const PricingPage = () => import(/* webpackChunkName: "group-payment" */ '@/pages/pricingPage/PricingPage');
const Community = () => import(/* webpackChunkName: "group-other" */ '@/pages/Community.vue');
const Redirect = () => import(/* webpackChunkName: "group-other" */ '@/pages/Redirect.vue');
const Playground = () => import(/* webpackChunkName: "group-other" */ '@/pages/Playground.vue');
const Privacy = () => import(/* webpackChunkName: "group-other" */ '@/pages/Privacy.vue');
const UserAgreement = () => import(/* webpackChunkName: "group-other" */ '@/pages/UserAgreement.vue');
const FAQs = () => import(/* webpackChunkName: "group-other" */ '@/pages/FAQs.vue');
const About = () => import(/* webpackChunkName: "group-other" */ '@/pages/About.vue');
const Terms = () => import(/* webpackChunkName: "group-other" */ '@/pages/Terms.vue');
const SupporterPaymentTerms = () => import(/* webpackChunkName: "group-other" */ '@/pages/SupporterPaymentTerms.vue');

const PaymentSuccess = () => import(/* webpackChunkName: "group-payment" */ '@/pages/PaymentSuccess');
const PaidTierDowngradeCancel = () => import(/* webpackChunkName: "group-payment" */ '@/pages/pricingPage/PaidTierDowngradeCancel');
const PaymentCancel = () => import(/* webpackChunkName: "group-payment" */ '@/pages/PaymentCancel');

export default {
  path: '/',
  name: 'Root',
  component: Root,
  children: [
    {
      path: '',
      name: 'Homepage',
      component: TrybHomepage,
    },
    { // TODO: Migrate this route to /e/ namespace
      path: 'redirect',
      name: 'Redirect',
      component: Redirect,
    },
    auth,
    contactUs,
    searchOutput,
    ...terms,
    ...CreatorSchool,
    AdminModule,
    {
      path: 'e', // stands for "escape"
      component: PassThrough,
      children: [
        {
          path: 'supporterpaymentterms',
          name: 'SupporterPaymentTerms',
          component: SupporterPaymentTerms,
        },
        {
          path: 'terms',
          name: 'Terms',
          component: Terms,
        },
        {
          path: 'playground',
          name: 'Playground',
          component: Playground,
          meta: {
            allowed: [Role.ADMIN],
          },
        },
        {
          path: 'privacy',
          name: 'Privacy',
          component: Privacy,
        },
        {
          path: 'useragreement',
          name: 'UserAgreement',
          component: UserAgreement,
        },
        {
          path: 'FAQ',
          name: 'FAQ',
          component: FAQs,
        },
        {
          path: 'about',
          name: 'About',
          component: About,
        },
        {
          path: 'community',
          name: 'Community',
          component: Community,
        },
        {
          path: 'pricing',
          name: 'Pricing',
          component: PricingPage,
        },
        {
          path: 'paid-tier-downgrade-cancel',
          name: 'PaidTierDowngradeCancel',
          component: PaidTierDowngradeCancel,
        },
        {
          path: 'paid-tier-success',
          name: 'PaidTierSuccess',
          component: PaymentSuccess,
          async beforeEnter(to, from, next) {
            to.query.message = 'Thank you for your support!';
            next();
          },
        },
        {
          path: 'paid-tier-cancel',
          name: 'PaidTierCancel',
          component: PaymentCancel,
        },
      ],
    },
    communities,
  ],
};
